// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__peydaFont_9eb845', '__peydaFont_Fallback_9eb845', system-ui, sans-serif"},"className":"__className_9eb845","variable":"__variable_9eb845"};